import { isDev } from "@/config.js";
// import axios from "axios";
import { SERVER_URL } from "@/config.js";

const Log = {
  success: (functionName, result) => {
    if (isDev) {
      console.log(functionName + " success", result);
    }
  },
  failure: (functionName, error) => {
    if (isDev) {
      console.log(functionName + " error", error);
    }
  },
};

const ReadFile = {
  readFileAsync: (file) =>
    new Promise((resolve, reject) => {
      const fileReader = new FileReader();

      fileReader.onload = () => {
        resolve(fileReader.result);
      };

      fileReader.onerror = () => {
        reject(fileReader.error);
      };

      fileReader.readAsArrayBuffer(file);
    }),
};

const Atomic = {
  useFunction: (fn) => {
    let isRunning = false;

    return function (...args) {
      if (isRunning) {
        return Promise.reject(
          new Error("The function " + this + "is already running")
        );
      }

      isRunning = true;

      return Promise.resolve(fn(...args)).finally(() => {
        isRunning = false;
      });
    };
  },
};

const Download = {
  downloadFile: async (cdnUrl, fileName) => {
    try {
      const serverUrl = `https://${SERVER_URL}/download-proxy`;
      window.open(
        `${serverUrl}?url=${encodeURIComponent(
          cdnUrl
        )}&filename=${encodeURIComponent(fileName)}`,
        "_blank"
      );
      // const params = { url: cdnUrl, filename: fileName };
      // const response = await axios.get(serverUrl, {
      //   params,
      //   responseType: "blob",
      // });
      // // 创建一个 Blob 对象并下载文件
      // const blob = new Blob([response.data]);
      // const url = window.URL.createObjectURL(blob);
      // const link = document.createElement("a");
      // link.href = url;
      // link.setAttribute("download", fileName);
      // document.body.appendChild(link);
      // link.click();
      // link.remove();
    } catch (error) {
      console.error(error);
      // 处理错误
      throw error;
    }
  },
};

export { Log, ReadFile, Atomic, Download };
